/* eslint-disable i18next/no-literal-string */
const WebpayOneClickLogo = (
    props: React.ImgHTMLAttributes<HTMLImageElement>
): React.ReactElement => {
    return (
        <img
            src="/webpay-one-click.webp"
            alt="webpay-one-click-logo"
            {...props}
        />
    )
}

export default WebpayOneClickLogo
